import { useMutation } from '@tanstack/react-query';
import { ApiClient, useApiClient } from 'api/context-provider/useApiClient';
import { throwOnError } from 'api/helpers';
import { operations } from 'api/schema';
import { queryClient } from 'configs/queryClient';
import useB2CVerificationRequestQuery from 'hooks/useB2CVerificationRequestQuery';

export type UpdateB2CVerificationRequest = operations['updateB2cVerificationState']['requestBody']['content']['application/json'];

async function updateB2CVerificationState(apiClient: ApiClient, id: string, state: UpdateB2CVerificationRequest) {
  return apiClient.PUT(`/op/v2/b2c-verification/{id}/update-state`, {
    params: { path: { id } },
    body: state,
  });
}

export function useUpdateB2CVerificationStateMutation(id: string, redirect: 'redirect' | 'no-redirect') {
  const apiClient = useApiClient();

  return useMutation({
    mutationFn: (state: UpdateB2CVerificationRequest) => throwOnError(updateB2CVerificationState(apiClient, id, state)),
    mutationKey: ['updateB2CVerificationState', id, redirect],
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: useB2CVerificationRequestQuery.getKey(id) });
    },
  });
}
